import { DndContext, PointerSensor, useDraggable, useDroppable, useSensor, useSensors } from "@dnd-kit/core";
import { useViewport } from "reactflow";
import React, { ReactNode, useEffect } from "react";
import { InterpType, NarrowedInterpretable } from "../interpretation/interpretable";
import { Flowchart, useInterpretable } from "./flowchart";
import { v4 } from "uuid"

export function Dropzone({ accepts, holds }: { accepts: InterpType[] | true, holds: string }) {
  const [interpretable] = useInterpretable(holds);
  const { isOver, setNodeRef, active, over } = useDroppable({
    id: holds,
    data: {
      accepts: accepts,
      uuid: holds
    },
  });

  const style = {
    backgroundColor: isOver && over ? 'purple' : undefined,
  };
  const InlineShape = Flowchart.getShapeOf(interpretable);
  if(!InlineShape) {
    return <>no inline shape yet</>
  }
  return (
    <div ref={setNodeRef} style={style}>
      <InlineShape data={holds}></InlineShape>
    </div>
  );
}

export function Draggable({ of, children = [] }: { of: string|(() => NarrowedInterpretable), children: ReactNode }) {
  // 'of' is what the draggable holds. It can either be a string, representing a uuid of a node already
  // in the interpretables, or it can be a function, representing a way to generate a new interpretable.
  const id = typeof(of) == "string" ? of : v4();

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: id,
    data: {
      uuidOrFunction: of,
      test: "test"
    },
  });
  const { zoom } = useViewport(); // relative to react viewport zoom
  const style = transform ? {// 10 and 20 are magic numbers so the cursor is not right on the draggable.
    transform: `translate(${10 + transform.x / zoom}px, ${20 + transform.y / zoom}px)`,
  } : undefined;

  return <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
    {children}
  </div>
}

/** 
 * This enables us to use custom sensors. 
 * Any context must be in a parent, not itself, and since FlowchartComponent is our only React component,
 * this is our workaround for being able to actually use a hook.
 */
export function CustomDragDropContext(props) {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    })
  )
  return <DndContext {...props} sensors={sensors}>
    {props.children}
  </DndContext>
}